import { apiFetch } from '../apiService';
import { API_ENDPOINTS } from '../config';

export interface RegistrationStatus {
  owner_registration_enabled: boolean;
  driver_registration_enabled: boolean;
}

export interface RegistrationSettings extends RegistrationStatus {
  id: number;
  created_at: string;
  updated_at: string;
  updated_by_email?: string;
}

export const registrationSettingsApi = {
  /**
   * Get current registration status (public endpoint)
   */
  getStatus: async (): Promise<RegistrationStatus> => {
    const response = await apiFetch<RegistrationStatus>(`${API_ENDPOINTS.REGISTRATION_SETTINGS}/status/`, {
      method: 'GET'
    }, false); // Public endpoint, no auth required
    
    if (!response.ok || !response.data) {
      throw new Error('Failed to fetch registration status');
    }
    return response.data;
  },

  /**
   * Get full registration settings (admin only)
   */
  getSettings: async (): Promise<RegistrationSettings> => {
    const response = await apiFetch<RegistrationSettings>(`${API_ENDPOINTS.REGISTRATION_SETTINGS}/settings/`, {
      method: 'GET'
    });
    
    if (!response.ok || !response.data) {
      throw new Error('Failed to fetch registration settings');
    }
    return response.data;
  },

  /**
   * Update registration settings (admin only)
   */
  updateSettings: async (settings: Partial<RegistrationStatus>): Promise<RegistrationSettings> => {
    const response = await apiFetch<RegistrationSettings>(`${API_ENDPOINTS.REGISTRATION_SETTINGS}/settings/update/`, {
      method: 'PATCH',
      body: JSON.stringify(settings)
    });
    
    if (!response.ok || !response.data) {
      throw new Error('Failed to update registration settings');
    }
    return response.data;
  },

  /**
   * Toggle owner registration (admin only)
   */
  toggleOwnerRegistration: async (): Promise<RegistrationSettings> => {
    const response = await apiFetch<RegistrationSettings>(`${API_ENDPOINTS.REGISTRATION_SETTINGS}/toggle/owner/`, {
      method: 'POST'
    });
    
    if (!response.ok || !response.data) {
      throw new Error('Failed to toggle owner registration');
    }
    return response.data;
  },

  /**
   * Toggle driver registration (admin only)
   */
  toggleDriverRegistration: async (): Promise<RegistrationSettings> => {
    const response = await apiFetch<RegistrationSettings>(`${API_ENDPOINTS.REGISTRATION_SETTINGS}/toggle/driver/`, {
      method: 'POST'
    });
    
    if (!response.ok || !response.data) {
      throw new Error('Failed to toggle driver registration');
    }
    return response.data;
  },
}; 